module.exports = __webpack_public_path__ + "0a95f951745ba02faa8773ea6a1ebaed.ttf";